import { combineReducers } from 'redux';
import { firebaseReducer as firebase } from 'react-redux-firebase';

import contentTypeIds from './contentTypeIds';
import { reducersFactory } from './contentfulRedux';

/*
  This creates the following object:]
  {
    news: (state, action) => ...
    someContenTypeId: (state, action) => ...
  }
*/

const reducers = reducersFactory(contentTypeIds);

/*
  The state structure that this creates is the following;
  {
    news: {
      '122-asdf22': { ...fields, id: '122-asdf22' },
      '123d-cdd': { ...fields, id: 123d-cdd },
    },
    someContenTypeId: { ... },
    entries: {
      '122-asdf22': { id: '122-asdf22', contentType: 'news' },
      '123d-cdd': { id: '123d-cdd', contentType: 'news' },
      '2222': { id: '2222', contentType: 'someContenTypeId' },
      ...
    }
  }
*/

export default combineReducers({
  firebase,
  ...reducers,
});



// WEBPACK FOOTER //
// ./src/store/reducers.js